// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kCx7","content":"styles_content__YD5gZ","tableWrap":"styles_tableWrap__9JhUG"};